/** 英文 */
export default {
    age: "Age",
    submit: "Submit",
    netWorkError: "The network link is abnormal. Please reconnect",
    example: {
        name: "ZhangSan"
    }
}